import { IAppState } from '../../../AppModulesWrapper';

import { ICoordinates } from '../../types/reducers/offer';

const MOSCOW_CENTER_COORDINATES: ICoordinates = {
  lat: 55.755864,
  lng: 37.621255,
};

export function selectOfferCoordinatesWithFallback(state: IAppState): ICoordinates {
  const { offer, user } = state.servicePickerWidget;

  const offerCoordinates = offer.geo?.coordinates;
  const userCoordinates = user.geo ? { lat: user.geo.lat, lng: user.geo.lng } : null;

  return offerCoordinates || userCoordinates || MOSCOW_CENTER_COORDINATES;
}
